export default __webpack_public_path__ + "a3a634b28da90fb46d3728126e8d69f5.png";